<template>
  <div class="manage-subscribe">
    <el-row type="flex" align="middle" justify="space-between" class="mb-l">
      <el-row type="flex" align="middle" class="page-title">
        <i class="el-icon-menu mr-s" />
        <h3>Danh sách Subscribe</h3>
      </el-row>
    </el-row>
    <el-form :model="form" inline ref="form">
      <el-form-item>
        <el-input
          v-model="form.email"
          @input="handleSearchSubscribe"
          clearable
          placeholder="Email"
          class="search mb-xl"
        />
      </el-form-item>
    </el-form>
    <el-row type="flex" justify="end">
      <el-button
        size="medium"
        type="primary"
        class="mb-m"
        @click="handleRefreshData"
      >
        <i class="el-icon-refresh"></i>
      </el-button>
    </el-row>
    <el-table :data="subscribes" border v-loading="callingAPI">
      <el-table-column label="#" type="index" align="center" width="50px" />
      <el-table-column label="Email">
        <template slot-scope="scope"> {{ scope.row.email }} </template>
      </el-table-column>
      <el-table-column label="Ngày subscribe">
        <template slot-scope="scope">
          {{ scope.row.created_at | convertDate }}
        </template>
      </el-table-column>
    </el-table>
    <el-row type="flex" justify="end" class="mt-m">
      <el-pagination
        background
        layout="prev, pager, next"
        :disabled="callingAPI"
        @current-change="handleChangePage"
        :currentPage="page"
        :pageSize="pageSize"
        :total="total"
      />
    </el-row>
  </div>
</template>

<script>
import { fetchSubscribe } from "@/services/subscribe";
export default {
  name: "ManageSubscribe",
  data() {
    return {
      callingAPI: false,
      debounce: null,

      subscribes: [],

      page: 1,
      pageSize: 10,
      total: 0,

      form: {
        email: "",
      },
    };
  },
  async beforeMount() {
    await this.loadData();
  },
  methods: {
    async handleRefreshData() {
      this.$refs.form.resetFields();
      await this.loadData();
    },

    async loadData(page = null) {
      try {
        this.callingAPI = true;
        const params = {
          email: this.form.email,
          page: page ? page : 1,
          per_page: this.pageSize,
        };
        const response = await fetchSubscribe(params);
        this.subscribes = response.data.data;
        this.total = response.data.total;
        this.callingAPI = false;
      } catch (error) {
        this.callingAPI = false;
      }
    },

    async handleSearchSubscribe() {
      clearTimeout(this.debounce);
      this.debounce = setTimeout(async () => {
        await this.loadData();
      }, 500);
    },

    async handleChangePage(page) {
      this.page = page;
      await this.loadData(page);
    },
  },
};
</script>

<style lang="scss" scoped>
.el-form-item {
  margin-bottom: 0;
}
</style>
